import type { ChannelsInfoResponse } from '../../../model/app-state/types.tsx';

export const FETCH_CHANNELS_INFO = 'state.actions.app-state.FETCH_CHANNELS_INFO' as const;
export type FetchChannelsInfoAction = {
	type: typeof FETCH_CHANNELS_INFO;
};
export const fetchChannelsInfo = (): FetchChannelsInfoAction => ({
	type: FETCH_CHANNELS_INFO,
});

export const START_FETCHING_CHANNELS_INFO =
	'state.actions.app-state.START_FETCHING_CHANNELS_INFO' as const;
export type StartFetchingChannelsInfoAction = {
	type: typeof START_FETCHING_CHANNELS_INFO;
};
export const startFetchingChannelsInfo = (): StartFetchingChannelsInfoAction => ({
	type: START_FETCHING_CHANNELS_INFO,
});

export const FETCH_CHANNELS_INFO_FAILURE =
	'state.actions.app-state.FETCH_CHANNELS_INFO_FAILURE' as const;
export type FetchChannelsInfoFailureAction = {
	type: typeof FETCH_CHANNELS_INFO_FAILURE;
};
export const fetchChannelsInfoFailure = (): FetchChannelsInfoFailureAction => ({
	type: FETCH_CHANNELS_INFO_FAILURE,
});

export const SET_CHANNELS_INFO = 'state.actions.app-state.SET_CHANNELS_INFO' as const;
export type SetChannelsInfoAction = {
	payload: ChannelsInfoResponse;
	type: typeof SET_CHANNELS_INFO;
};
export const setChannelsInfo = (payload: ChannelsInfoResponse): SetChannelsInfoAction => ({
	payload,
	type: SET_CHANNELS_INFO,
});

export type Action =
	| FetchChannelsInfoAction
	| StartFetchingChannelsInfoAction
	| FetchChannelsInfoFailureAction
	| SetChannelsInfoAction;
